export default "__VITE_ASSET__DqprP_xL__"